import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import axios from 'axios';
import ConfigManager from '../managers/ConfigManager';

var FHIRService = /*#__PURE__*/function () {
  function FHIRService(resourceType) {
    _classCallCheck(this, FHIRService);

    this.baseUrl = ConfigManager.appConfig.settings.fhirBaseUrl;
    this.resourceType = resourceType;
  }

  _createClass(FHIRService, [{
    key: "_mapToQueryParams",
    value: function _mapToQueryParams(param) {
      if (!param) {
        return '';
      }

      var queryParams = '';
      Object.keys(param).forEach(function (filterName) {
        var filterValue = param[filterName];
        var queryParam = "".concat(encodeURI(filterName), "=").concat(encodeURI(filterValue));
        queryParams += queryParams.length ? "&".concat(queryParam) : queryParam;
      });
      return queryParams;
    }
  }, {
    key: "transaction",
    value: function () {
      var _transaction = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(resource) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return axios.post(this.baseUrl, resource);

              case 2:
                return _context.abrupt("return", _context.sent);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function transaction(_x) {
        return _transaction.apply(this, arguments);
      }

      return transaction;
    }()
  }, {
    key: "create",
    value: function () {
      var _create = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(resource) {
        var url;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                url = "".concat(this.baseUrl, "/").concat(this.resourceType);
                _context2.next = 3;
                return axios.post(url, resource);

              case 3:
                return _context2.abrupt("return", _context2.sent);

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function create(_x2) {
        return _create.apply(this, arguments);
      }

      return create;
    }()
  }, {
    key: "read",
    value: function () {
      var _read = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(id) {
        var url;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                url = "".concat(this.baseUrl, "/").concat(this.resourceType, "/").concat(id);
                _context3.next = 3;
                return axios.get(url);

              case 3:
                return _context3.abrupt("return", _context3.sent);

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function read(_x3) {
        return _read.apply(this, arguments);
      }

      return read;
    }()
  }, {
    key: "vread",
    value: function () {
      var _vread = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(id, vid) {
        var url;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                url = "".concat(this.baseUrl, "/").concat(this.resourceType, "/").concat(id, "/_history/").concat(vid);
                _context4.next = 3;
                return axios.get(url);

              case 3:
                return _context4.abrupt("return", _context4.sent);

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function vread(_x4, _x5) {
        return _vread.apply(this, arguments);
      }

      return vread;
    }()
  }, {
    key: "update",
    value: function () {
      var _update = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(id, resource) {
        var url;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                url = "".concat(this.baseUrl, "/").concat(this.resourceType, "/").concat(id);
                _context5.next = 3;
                return axios.put(url, resource);

              case 3:
                return _context5.abrupt("return", _context5.sent);

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function update(_x6, _x7) {
        return _update.apply(this, arguments);
      }

      return update;
    }()
  }, {
    key: "patch",
    value: function () {
      var _patch2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(id, _patch) {
        var url;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                url = "".concat(this.baseUrl, "/").concat(this.resourceType, "/").concat(id);
                _context6.next = 3;
                return axios.patch(url, _patch);

              case 3:
                return _context6.abrupt("return", _context6.sent);

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function patch(_x8, _x9) {
        return _patch2.apply(this, arguments);
      }

      return patch;
    }()
  }, {
    key: "delete",
    value: function () {
      var _delete2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(id) {
        var url;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                url = "".concat(this.baseUrl, "/").concat(this.resourceType, "/").concat(id);
                _context7.next = 3;
                return axios.delete(url);

              case 3:
                return _context7.abrupt("return", _context7.sent);

              case 4:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function _delete(_x10) {
        return _delete2.apply(this, arguments);
      }

      return _delete;
    }()
  }, {
    key: "history",
    value: function () {
      var _history = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(id) {
        var url;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                url = "".concat(this.baseUrl, "/").concat(this.resourceType, "/").concat(id, "/_history");
                _context8.next = 3;
                return axios.get(url);

              case 3:
                return _context8.abrupt("return", _context8.sent);

              case 4:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function history(_x11) {
        return _history.apply(this, arguments);
      }

      return history;
    }()
  }, {
    key: "search",
    value: function () {
      var _search = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(params) {
        var _this = this;

        var url, queryParamsList;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                url = "".concat(this.baseUrl, "/").concat(this.resourceType); // Append query string parameters if exist

                if (params && params.length) {
                  queryParamsList = [];
                  params.forEach(function (param) {
                    var queryParams = _this._mapToQueryParams(param);

                    queryParamsList.push(queryParams);
                  });
                  url += "?".concat(queryParamsList.join('&'));
                }

                _context9.next = 4;
                return axios.get(url);

              case 4:
                return _context9.abrupt("return", _context9.sent);

              case 5:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function search(_x12) {
        return _search.apply(this, arguments);
      }

      return search;
    }()
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return FHIRService;
}();

export { FHIRService as default };
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(FHIRService, "FHIRService", "/home/runner/html/nextcloud/apps/ehr/js/platform/core/src/services/FHIRService.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();